import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTablePaddedCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { MoneyText } from "@redotech/redo-web/fx/money-text";
import { toMoney } from "@redotech/redo-web/fx/to-money";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";

const catalogEntry = fgColumnEntries.shippingPaid;

export const ShippingPaidColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
    <RedoTablePaddedCell>
      <Text as="span" fontSize="xs" fontWeight="regular" textColor="tertiary">
        <MoneyText
          struck
          value={toMoney({
            amount: Number(row.totalShippingCost.amount),
            currency: row.totalShippingCost.currency,
          })}
        />
      </Text>
    </RedoTablePaddedCell>
  ),
  onClick: (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  },
  width: catalogEntry.defaultWidth,
  hidden: false,
};
